import { t } from "i18next";
import React, { useEffect, useRef, useState } from "react";
import { GameProviderRequest } from "../../../common/types/Casino/GameProvider";

import "./SelectProviderPopap.scss";

interface ISelectProviderPopap {
  setProviderPopapOpen: React.Dispatch<React.SetStateAction<boolean>>;
  providersList: GameProviderRequest | undefined;
  setSelectedProviders: React.Dispatch<React.SetStateAction<number[]>>;
  selectedProviders: number[];
  setShowByParams: React.Dispatch<React.SetStateAction<boolean>>;
  searchInput: string;
  handleSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  filteredData: GameProviderRequest | undefined;
}

const SelectProviderPopap = ({
  setProviderPopapOpen,
  providersList,
  setSelectedProviders,
  selectedProviders,
  setShowByParams,
  searchInput,
  handleSearchChange,
  filteredData,
}: ISelectProviderPopap) => {
  const [selectedProviderPrev, setSelectedProviderPrev] =
    useState<number[]>(selectedProviders);

  const handleClosePopap = () => {
    setProviderPopapOpen(false);
  };

  const handleApply = () => {
    setSelectedProviders(selectedProviderPrev);
    setProviderPopapOpen(false);
    setShowByParams(true);
  };

  const handleSelectItem = (item: number) => {
    setSelectedProviderPrev((prevState) => {
      if (prevState.includes(item)) {
        return prevState.filter((existingId: number) => existingId !== item);
      } else {
        return [...prevState, item];
      }
    });
  };

  const wrapperRef = useRef(null);

  const [inputActive, setInputActive] = useState(false);

  const handleTapOutside = (event: MouseEvent | TouchEvent) => {
    if (
      wrapperRef.current &&
      !(wrapperRef.current as HTMLElement).contains(event.target as Node)
    ) {
      setInputActive(false);
    }
  };

  const handleOpenInput = () => {
    setInputActive((prev) => !prev);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleTapOutside);
    document.addEventListener("touchstart", handleTapOutside);
    return () => {
      document.removeEventListener("mousedown", handleTapOutside);
      document.removeEventListener("touchstart", handleTapOutside);
    };
  }, []);
  return (
    <div className="popup-holder-bc full-screen">
      <div className="popup-middleware-bc">
        <div className="popup-inner-bc">
          <div className="casino-category-providers opened">
            <div className="casino-category-providers-header">
              <h3 className="casino-category-providers-heading">
                {t("casino.Providers")}
              </h3>
              <button
                className="providers-close-button-bc bc-i-close-remove "
                type="button"
                onClick={handleClosePopap}
              />
            </div>
            <div className="casino-category-providers-select">
              <div className="casino-category-provider-count-bc">
                {selectedProviderPrev.length === 0
                  ? "No providers selected"
                  : `${selectedProviderPrev.length} SELECTED`}
              </div>
              <div
                className={`sport-search-bc ${
                  inputActive ? "active" : ""
                } search-custom`}
              >
                {inputActive ? (
                  <input
                    type="text"
                    className="ss-input-bc"
                    placeholder="Search provider..."
                    defaultValue=""
                    value={searchInput}
                    onChange={handleSearchChange}
                  />
                ) : null}
                <div
                  className="ss-icon-holder-bc custom-btn-position"
                  onClick={handleOpenInput}
                >
                  <i
                    className={`ss-icon-bc bc-i-${
                      inputActive ? "close-remove" : "search"
                    }`}
                  />
                </div>
              </div>
            </div>
            <div
              className="casino-providers-list"
              data-scroll-lock-scrollable=""
            >
              {providersList && filteredData ? (
                Object.keys(filteredData).map((item) => {
                  return filteredData[item]?.map((item) => (
                    <div
                      className={`casino-providers-list-item ${
                        selectedProviderPrev.includes(item.id) ? "selected" : ""
                      }`}
                      data-badge=""
                      key={item.id}
                      onClick={() => handleSelectItem(item.id)}
                    >
                      {item.name}
                      <span className="checked-icon bc-i-checked" />
                    </div>
                  ));
                })
              ) : (
                <>
                  {providersList ? (
                    Object.keys(providersList).map((item) => {
                      return providersList[item]?.map((item) => (
                        <div
                          className={`casino-providers-list-item ${
                            selectedProviderPrev.includes(item.id)
                              ? "selected"
                              : ""
                          }`}
                          data-badge=""
                          key={item.id}
                          onClick={() => handleSelectItem(item.id)}
                        >
                          {item.name}
                          <span className="checked-icon bc-i-checked" />
                        </div>
                      ));
                    })
                  ) : (
                    <></>
                  )}
                </>
              )}
            </div>
            <div className="save-filter-button-bc">
              <button
                className="btn a-color "
                type="button"
                title="Apply"
                onClick={handleApply}
              >
                <span>{t("admin.Apply")}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { SelectProviderPopap };
